import { render } from "./AGBDialog.vue?vue&type=template&id=43a5ea18"
import script from "./AGBDialog.vue?vue&type=script&lang=js"
export * from "./AGBDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__